import React from 'react';
import {
    Paper,
    Typography,
    FormGroup,
} from '@material-ui/core';
import { withStyles } from "@material-ui/core/styles";
import PropTypes from 'prop-types';
import QRCode from "react-qr-code";

const styles = () => ({
    paper: {
        transform: 'scale(0.8)',
        transformOrigin: 'top left',
        width: '100%',
        height: '100%',
        marginTop: '5px',
        minWidth: 960,
        textAlign: 'center',
        justifyContent: 'center',
    },
    category: {
        marginTop: '150px',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight:'70px',
        marginLeft: '40px'
    },
    address: {
        marginTop: '30px',
        marginBottom: '30px',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight:'70px',
        marginLeft: '40px'
    },
    nickName: {
        marginTop: '30px',
        marginBottom: '50px',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight:'70px',
        marginLeft: '40px'
    },
    title:{
        marginTop: '50px',
        fontSize: '55px',
        justifyContent: 'center',
        textAlign:'center',
        fontWeight: "bold",
        borderBottom: 'solid 10px #FFF',
    },
    inputKeyword:{
        fontSize:'33px',
        margin: '0px 0px 10px 210px',
        textAlign:'left',
        width: 'auto'
    },
    displayFlex: {
        display: 'flex'
    },
    verticalSpace: {
        margin: '25px 20px 20px 100px',
    },
    searchButtonSpace: {
        margin: '25px 0px 10px 10px',
        fontSize:'21px',
    },
    qr:{
        marginTop: '60px',
        alignItems: 'center',
        justifyContent: 'center',
    },
    left:{
        display: 'inline-block',
    },
    marginAuto:{
        fontSize:'23px',
        margin: '0px auto 10px 25px',
        width: 300
    },
    conditionLeft: {
        fontSize:'28px',
        textAlign:'left',
    },
    printDescriptionArea:{
        marginTop:'50px'
    },
    printDescription:{
        textAlign:'left',
        marginLeft: '250px',
        fontSize: '22px'
    }
});
class Print extends React.Component{
    render(){
        const { classes, src, nameObj } = this.props;
        return (
            <div elevation={3} className={classes.paper} >
                <div className={classes.left}>
                    <Typography className={classes.title} variant="h4" component="p">
                        {nameObj.PRINT_TITLE}
                    </Typography>
                    <Paper elevation={2} variant="outlined"></Paper>
                    <FormGroup className={classes.category} row>
                        <Typography variant="h3" className={classes.inputKeyword}>
                            {`${nameObj.KUBUN_NAME}：`}
                        </Typography>
                        <div className={classes.marginAuto}>
                            <Typography variant="h3" className={classes.conditionLeft}>
                                {`${src.categoryName}`}
                            </Typography>
                        </div>
                    </FormGroup>
                    <FormGroup className={classes.address} row>
                        <Typography variant="h3" className={classes.inputKeyword}>
                            {`${nameObj.PRINT_ADDRESS_NAME}：`}
                        </Typography>
                        <div className={classes.marginAuto}>
                            <Typography variant="h3" className={classes.conditionLeft}>
                                {`${src.address}`}
                            </Typography>
                        </div>
                    </FormGroup>
                    { src.displayNickName && (
                        <FormGroup className={classes.address} row>
                            <Typography variant="h3" className={classes.inputKeyword}>
                                {`${nameObj.PRINT_USER_NAME}：`}
                            </Typography>
                            <div className={classes.marginAuto}>
                                <Typography variant="h3" className={classes.conditionLeft}>
                                    {`${src.nickName} ${nameObj.PRINT_NAME_HONORIFICS}`}
                                </Typography>
                            </div>
                        </FormGroup>
                    )}
                    <FormGroup className={classes.qr} row>
                        <div style={{ height: "auto", margin: "0 auto", maxWidth: 400, width: "100%" }}>
                            <QRCode
                                size={400}
                                style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                                value={`${src.liffUrl}/?cid=${src.categoryId}&addId=${src.address}`}
                                viewBox={`0 0 400 400`}
                            />
                        </div>
                    </FormGroup>
                    <FormGroup　className={classes.printDescriptionArea}>　
                        {nameObj.PRINT_TERMS.split('\n').map((line) => {
                            return (
                                <div className={classes.printDescription}>{line}</div>
                            )
                        })}
                    </FormGroup>
                </div>
            </div>
        );
    }
};

Print.propTypes = {
    classes: PropTypes.object.isRequired,
    src: PropTypes.object.isRequired,
    nameObj: PropTypes.object.isRequired,
};

export default withStyles(styles)(Print);
